import { render, staticRenderFns } from "./AppProcesadorTexto.vue?vue&type=template&id=1274fd34"
import script from "./AppProcesadorTexto.vue?vue&type=script&lang=js"
export * from "./AppProcesadorTexto.vue?vue&type=script&lang=js"
import style0 from "./AppProcesadorTexto.vue?vue&type=style&index=0&id=1274fd34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports